import { render, staticRenderFns } from "./bottomNavbarResponsive.vue?vue&type=template&id=85dadc10&scoped=true&"
import script from "./bottomNavbarResponsive.vue?vue&type=script&lang=js&"
export * from "./bottomNavbarResponsive.vue?vue&type=script&lang=js&"
import style0 from "./bottomNavbarResponsive.vue?vue&type=style&index=0&id=85dadc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dadc10",
  null
  
)

export default component.exports